import type { ThunkDependencies } from "single-spa/store/thunk-dependencies";
import type { ThunkDispatchCommon, ThunkGetState } from "single-spa/store/types";
import { managementActions } from "../../store/action-creators";

export const getHsMappingFieldsThunk =
    () => async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies) => {
        try {
            dispatch(managementActions.hubspot.getMappingFieldsAsync.request());

            const response = await deps.si.api.management.getHsMappingFields();
            dispatch(managementActions.hubspot.getMappingFieldsAsync.success(response));
        } catch (error) {
            dispatch(managementActions.hubspot.getMappingFieldsAsync.failure(error));
        }
    };

export const putHsFilterFieldsThunk =
    (fields: string[]) =>
    async (dispatch: ThunkDispatchCommon, _getState: ThunkGetState, deps: ThunkDependencies): Promise<boolean> => {
        try {
            dispatch(managementActions.hubspot.putFilterFieldsAsync.request());
            const { value } = await deps.si.api.management.putHsFilterFields(fields);
            if (value) {
                await dispatch(getHsMappingFieldsThunk());
                dispatch(managementActions.hubspot.putFilterFieldsAsync.success(value));
            }
            return value;
        } catch (error) {
            dispatch(managementActions.hubspot.putFilterFieldsAsync.failure(error));
            return false;
        }
    };
